import React, { useState } from 'react';

const SellerStoreCategory = ({ productCategory, onSelectCategory }) => {
    const [activeCategoryId, setActiveCategoryId] = useState('all');

    const getCategoryCount = (item) => {
        return item?.totalProduct ?? item?.productCount ?? item?.count ?? null;
    };

    return (
        <div className="seller-store-category">
            <div className="d-flex flex-column gap-10 mt-5">
                <button
                    type="button"
                    onClick={() => {
                        setActiveCategoryId('all');
                        if (onSelectCategory) {
                            onSelectCategory(undefined);
                        }
                    }}
                    className="d-flex align-items-center justify-content-between border-0 bg-transparent py-10 px-20"
                    style={{ textAlign: 'left' }}
                >
                    <span className="fw-medium" style={{ color: '#000000', fontSize: '14px' }}>
                        All Products
                    </span>
                    <i className="ph ph-caret-right text-black" />
                </button>

                {Array.isArray(productCategory) &&
                    productCategory.length > 0 &&
                    productCategory.map((item) => {
                        const categoryCount = getCategoryCount(item);
                        const isActive = activeCategoryId === item.id;

                        return (
                            <button
                                key={item.id}
                                type="button"
                                onClick={() => {
                                    setActiveCategoryId(item.id);
                                    if (onSelectCategory) {
                                        onSelectCategory(item.id);
                                    }
                                }}
                                className="d-flex align-items-center justify-content-between border-0 bg-transparent py-10 px-20"
                                style={{ textAlign: 'left' }}
                            >
                                <span className="fw-medium" style={{ color: '#000000', fontSize: '14px' }}>
                                    {item.name}
                                    {categoryCount !== null && <span className="ms-1">({categoryCount})</span>}
                                </span>
                                <i className="ph ph-caret-right text-black" />
                            </button>
                        );
                    })}
            </div>
        </div>
    );
};

export default SellerStoreCategory;
